import { authClient } from "@/lib/auth/client";
import type { AuthUserPayload } from "@/lib/api/types";

export function useSession() {
  const { data, isPending, isRefetching, error, refetch } = authClient.useSession();

  const connected = Boolean(data?.session && data?.user);
  const user = (data?.user ?? null) as AuthUserPayload | null;
  const expiresAt = data?.session?.expiresAt ? new Date(data.session.expiresAt).toISOString() : undefined;

  return {
    loading: isPending,
    refreshing: isRefetching,
    connected,
    user,
    expiresAt,
    error,
    refresh: () => refetch(),
  };
}
